const styles = (theme) => ({
        container: {
            zIndex: '99999999',
            position: 'fixed',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgb(242, 242, 242, 0.7)'
           
        },
        wrapper: {
            position: 'absolute',
            //backgroundColor: 'gray',
            top: '30%',      
            width: '100%' 
    
        },
        paper: {
            width: '30em',
            margin: 'auto',
            padding: theme.spacing.unit*2,
            [theme.breakpoints.down('xs')]: {
               width: '90%'
            },
            textAlign: 'center'
        },
        header: {
            width: '100%',
        },
        icons: {
            width: '1.8em',
            height: '1.8em',
        },
        title: {

        },
        contentWrapper: {
            width: '100%',
           // backgroundColor: 'green',
        },
        content: {
            paddingTop: '1em',
            paddingBottom: '1em'

        },
        footer: {
            width: '100%',
            //height: '32%',
            //backgroundColor: 'blue',
        },
        buttonWrapper : {
            widht: '100%'
            
        },
        button: {
            marginRight: theme.spacing.unit,
        },

    })

    export default styles


// WEBPACK FOOTER //
// ./src/Container/PopUps/popUpStyles.js